'use client';
import { useEffect } from 'react';
import { useStore } from '../../../utils/store';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  setLocalAccessToken,
  setLocalIDToken,
  setLocalRefreshToken,
  setLoginName,
} from '../../../utils/storageUtil';

const LoginProcess: React.FC = () => {
  const navigate = useNavigate();
  const { setIsAdmin, setIsLoginUsername } = useStore();
  const location = useLocation();

  useEffect(() => {
    const Login = async (
      accessToken: string,
      idToken: string,
      refreshToken: string,
      username: any
    ) => {
      try {
        // Store tokens in localStorage
        setLocalAccessToken(accessToken);
        setLocalIDToken(idToken);
        setLocalRefreshToken(refreshToken);
        setLoginName(username);
        // Set admin state
        setIsAdmin(accessToken);
        setIsLoginUsername(username);
        // Navigate to dashboard
        window.location.href = '#/dashboard';
      } catch (error) {
        // Redirect to login on failure
        navigate('/');
      }
    };

    // Parse query parameters
    const params = new URLSearchParams(location.search);
    const accessToken = params.get('access_token');
    const idToken = params.get('id_token');
    const refreshToken = params.get('refresh_token');
    const username = params.get('username') ? params.get('username') : '';

    if (accessToken && idToken && refreshToken) {
      Login(accessToken, idToken, refreshToken, username);
    } else {
      navigate('/');
    }
  }, [location, navigate, setIsAdmin]);

  return <div className="processing-login">Processing login...</div>;
};

export default LoginProcess;
